import React from 'react';
import clsx from 'clsx';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import useStyles from './style';
const Tag = ({
  classes: passedClasses = {},
  className = '',
  color = 'primary',
  icon = null,
  label = 'Tag',
  onClick = () => {},
  shade = 'main',
  size = 'large',
}) => {
  const classes = useStyles({
    color,
    shade,
    size,
  });

  return (
    <span
      className={clsx(className, passedClasses.root, classes.root)}
      onClick={onClick}
    >
      {icon && (
        <img
          alt=''
          src={icon}
          className={clsx('mr-1', passedClasses.icon, classes.icon)}
        />
      )}
      <Typography
        className={clsx(passedClasses.label, classes.label)}
        variant='caption'
      >
        {label}
      </Typography>
    </span>
  );
};

export default Tag;
